export default __webpack_public_path__ + "static/media/FurnitureItem15.009c7d42.png";